import { render, staticRenderFns } from "./NavTop.vue?vue&type=template&id=2f7a54ed&scoped=true&"
import script from "./NavTop.vue?vue&type=script&lang=js&"
export * from "./NavTop.vue?vue&type=script&lang=js&"
import style0 from "./NavTop.vue?vue&type=style&index=0&id=2f7a54ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a54ed",
  null
  
)

export default component.exports